import { render, staticRenderFns } from "./OrderSetting.vue?vue&type=template&id=1b281dbc&"
import script from "./OrderSetting.vue?vue&type=script&lang=ts&"
export * from "./OrderSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports